<template>
  <BasePopup v-model="isPopupOpen" customClass="custom-popup mn-wd1000 full sales-invoice">
  <div class="popup-header mt12">
    <h3 class="title">거래명세서</h3>
    <button type="button" class="btn-cancel" @click="handleClose(false)"></button>
    <HconCheckBox v-if="hasCanceledItem" type="default" v-model:checked="showCancelItem" label="취소 상품 보기" :hide-label="false" />
  </div>
  <div class="popup-body" id="print-area">
    <div class="scroll">
    <div class="receipt-wrap">
      <div class="invoice-title">
        <h4 class="title">전자 거래명세서</h4>
        <div class="number-wrap">
          <dl class="invoice-number">
            <dt>수주번호</dt>
            <dd></dd>
          </dl>
          <dl class="invoice-number">
            <dt>출하번호</dt>
            <dd></dd>
          </dl>
        </div>
      </div>
      <!-- 기본 정보 s -->
      <div class="invoice-wrap">
        <div class="invoice-box">
          <h5 class="box-title">공급자</h5>
          <div class="invoice-table">
            <table class="tbl-type tbl-type-row">
              <caption>공급자</caption>
              <colgroup>
                <col style="width:20%" />
                <col style="width:30%" />
                <col style="width:20%" />
                <col style="width:30%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row" class="left">등록번호<sup class="required">*</sup></th>
                  <td colspan="3" class="left">{{ HconCommonUtils.format.bzrn('1018190575') }}</td>
                </tr>
                <tr>
                  <th scope="row" class="left">상호<sup class="required">*</sup></th>
                  <td class="left">(주)현대이지웰</td>
                  <th scope="row" class="left">대표자명<sup class="required">*</sup></th>
                  <td class="left relative">박종선
                    <img src="@/assets/images/pc/sub-hcon/img-ezwel-seal.jpeg" alt="현대이지웰 인감" class="provider-seal"/>
                  </td>
                </tr>
                <tr>
                  <th scope="row" class="left">사업장주소<sup class="required">*</sup></th>
                  <td colspan="3" class="left">서울특별시 서대문구 충정로 23, 8층 일부, 9, 10층<br>(충정로 3가, 풍산빌딩)</td>
                </tr>
                <tr>
                  <th scope="row" class="left">업태</th>
                  <td class="left">서비스</td>
                  <th scope="row" class="left">종목</th>
                  <td class="left">전자상거래</td>
                </tr>
                <tr>
                  <th scope="row" class="left">부서명</th>
                  <td class="left">지원사업부 Hcon팀</td>
                  <th scope="row" class="left">담당자</th>
                  <td class="left">복민주</td>
                </tr>
                <tr>
                  <th scope="row" class="left">연락처</th>
                  <td colspan="3" class="left">{{ HconCommonUtils.format.phone('0221610880') }}</td>
                </tr>
                <tr>
                  <th scope="row" class="left">E-mail</th>
                  <td colspan="3" class="left">hcon@hyundaiezwel.com</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="invoice-box">
          <h5 class="box-title">공급받는자</h5>
          <div class="invoice-table">
            <table class="tbl-type tbl-type-row">
              <caption>공급받는자</caption>
              <colgroup>
                <col style="width:20%" />
                <col style="width:30%" />
                <col style="width:20%" />
                <col style="width:30%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row" class="left">등록번호<sup class="required">*</sup></th>
                  <td colspan="3" class="left">{{ HconCommonUtils.format.bzrn(ordDsmInfo?.buyerData.bzrn||'') }}</td>
                </tr>
                <tr>
                  <th scope="row" class="left">상호<sup class="required">*</sup></th>
                  <td class="left">{{ ordDsmInfo?.buyerData.bzcoNm }}</td>
                  <th scope="row" class="left">성명<sup class="required">*</sup></th>
                  <td class="left">{{ ordDsmInfo?.buyerData.rpsrNm }}</td>
                </tr>
                <tr>
                  <th scope="row" class="left">사업장주소<sup class="required">*</sup></th>
                  <td colspan="3" class="left">{{ ordDsmInfo?.buyerData.basAdr }}</td>
                </tr>
                <tr>
                  <th scope="row" class="left">업태</th>
                  <td class="left">{{ ordDsmInfo?.buyerData.hcBizcNm }}</td>
                  <th scope="row" class="left">종사업장번호</th>
                  <td class="left"></td>
                </tr>
                <tr>
                  <th scope="row" class="left">종목</th>
                  <td colspan="3" class="left">{{ ordDsmInfo?.buyerData.hcBiztpNm }}</td>
                </tr>
                <tr>
                  <th scope="row" class="left">부서명</th>
                  <td class="left">{{ ordDsmInfo?.buyerData.hcUsrDeptNm }}</td>
                  <th scope="row" class="left">담당자</th>
                  <td class="left">{{ ordDsmInfo?.buyerData.hcUsrNm }}</td>
                </tr>
                <tr>
                  <th scope="row" class="left">연락처</th>
                  <td class="left">{{ HconCommonUtils.format.phone(ordDsmInfo?.buyerData.cbleTelno||'') }}</td>
                  <th scope="row" class="left">휴대폰</th>
                  <td class="left">{{ HconCommonUtils.format.phone(ordDsmInfo?.buyerData.hcUsrMblTelno||'') }}</td>
                </tr>
                <tr>
                  <th scope="row" class="left">E-mail</th>
                  <td colspan="3" class="left">{{ ordDsmInfo?.buyerData.hcUsrEmlAdr }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- 기본 정보 e -->

      <!-- 거래 요약 s -->
      <div class="invoice-list">
        <h5 class="a11y-blind">거래 요약 정보</h5>
        <table class="tbl-type tbl-auto">
          <caption>거래 요약 정보</caption>
          <colgroup>
            <col style="width:17%;">
            <col />
            <col style="width:25%;">
            <col style="width:10%;">
            <col style="width:10%;">
            <col style="width:10%;">
          </colgroup>
          <thead>
            <tr>
              <th scope="col" class="small">거래일자</th>
              <th scope="col" class="small pl16 pr120">주문번호</th>
              <th scope="col" class="small right pr16">정상가</th>
              <th scope="col" class="small right pr16">할인금액</th>
              <th scope="col" class="small right pr16">공급가액<sup class="required">*</sup></th>
              <th scope="col" class="small right pr16">총합계금액</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="fs14 text-gray">{{ HconCommonUtils.format.dateTimeNoSec(tgtOrdDtm) }}</td>
              <td class="pr120">{{ tgtOrdNo }}</td>
              <td class="right ws-nowrap">{{ HconCommonUtils.format.addWon(totalAmount?.summaryNrmlPrc) }}</td>
              <td class="right ws-nowrap">{{ HconCommonUtils.format.addWon(totalAmount?.summaryDcAmt) }}</td>
              <td class="right ws-nowrap">{{ HconCommonUtils.format.addWon(totalAmount?.summaryAmt) }}</td>
              <td class="right ws-nowrap">{{ HconCommonUtils.format.addWon(totalAmount?.summaryAmt) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- 거래 요약 e -->
      
      <!-- 상세 주문 내역 s -->
      <div class="invoice-list">
        <h5 class="a11y-blind">상세 주문 내역</h5>
        <table class="tbl-type tbl-auto">
          <caption>상세 주문 내역</caption>
          <colgroup>
            <col style="width:7%;">
            <col style="width:16%;">
            <col />
            <col style="width:7%;">
            <col style="width:9%;">
            <col style="width:9%;">
            <col style="width:9%;">
            <col style="width:9%;">
            <col style="width:7%;">
          </colgroup>
          <thead>
            <tr>
              <th scope="col" class="small">NO</th>
              <th scope="col" class="small">구매일시</th>
              <th scope="col" class="small">품목명</th>
              <th scope="col" class="small right pr16">수량</th>
              <th scope="col" class="small right pr16">단가</th>
              <th scope="col" class="small right pr16">정상가</th>
              <th scope="col" class="small right pr16">할인금액</th>
              <th scope="col" class="small right pr16">공급가액<sup class="required">*</sup></th>
              <th scope="col" class="small">비고</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in displayGoodsList" :key="index">
              <tr>
                <td>{{ index+1 }}</td>
                <td class="fs14 text-gray">{{ HconCommonUtils.format.dateTimeNoSec(item.ordDtm) }}</td>
                <td class="left font-bold">{{ item.gdsNm }}</td>
                <td class="right ws-nowrap">{{ item.displayQty }}</td>
                <td class="right ws-nowrap">{{ HconCommonUtils.format.expComma(item.realSellPrc) }}</td>
                <td class="right ws-nowrap">{{ HconCommonUtils.format.expComma(item.displayNrmlPrc) }}</td>
                <td class="right ws-nowrap">{{ HconCommonUtils.format.expComma(item.displayDcAmt) }}</td>
                <td class="right ws-nowrap">{{ HconCommonUtils.format.expComma(item.displayAmt) }}</td>
                <td>{{ item.isCancelRow === true ? '취소' : '구매' }}</td>
              </tr>
            </template>
          </tbody>
          <tfoot class="total">
            <tr>
              <th scope="row" colspan="5" class="left pl32">총합계금액</th>
              <td class="right ws-nowrap">{{ HconCommonUtils.format.expComma(totalAmount?.displayNrmlPrc) }}</td>
              <td class="right ws-nowrap">{{ HconCommonUtils.format.expComma(totalAmount?.displayDcAmt) }}</td>
              <td class="right ws-nowrap">{{ HconCommonUtils.format.expComma(totalAmount?.displayAmt) }}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
      <!-- 상세 주문 내역 e -->
      <h5 class="fs18 font-bold">안내사항</h5>
      <ul class="dot-list mt18">
        <li>거래명세서는 결제가 완료되었음을 증명하는 용도로만 활용 가능하며, 소득공제용 영수증 및 매입 세금계산서로는 활용할 수 없습니다.</li>
        <li>거래명세서는 세무상의 지출 증빙 효력이 없으므로 법적 증빙자료로 사용할 수 없습니다.</li>
        <li>상기 내역은 조회 시점을 기준으로 환불 및 취소 금액이 반영된 결제 금액에 대하여 발급됩니다.</li>
        <li>적립금 사용금액은 거래명세서 내에 별도 표기되지 않습니다.</li>
      </ul>
    </div>
  </div>
  </div>
  <div class="popup-footer jc-c">
    <div class="button-box col2">
      <button type="button" class="btn lg" @click="handleClose(true)">인쇄/저장하기</button>
    </div>
  </div>
</BasePopup>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import BasePopup from '@/components/com/HconComBasePopup.vue';
import HconCheckBox from '@/components/com/HconComPCCheckbox.vue';
import { HconCommonUtils } from "@/utils/hcon-common-utils";
import type { DetailedStatementDto, ReceiptGoodsDto } from '@/types/order/backend-dto-types';
import { usePrint } from '@/composables/hconUsePrint';
const { printPage } = usePrint('#print-area') // 인쇄

// 필요 변수 선언
const isPopupOpen = ref(false); // 해당 팝업 오픈여부
const showCancelItem = ref(false); // 취소상품보기여부
const tgtOrdNo = ref(''); // 부모로부터 전달받은 변수
const tgtOrdDtm = ref(''); // 부모로부터 전달받은 변수

// 팝업 닫힘
const handleClose = (isPrint: boolean) => {
  if (isPrint) printPage();
  isPopupOpen.value = false;
  showCancelItem.value = false;
}
// 팝업 열림
const handleOpen = (ordNo: string, ordDtm: string) => {
  tgtOrdNo.value = ordNo;
  tgtOrdDtm.value = ordDtm;
  isPopupOpen.value = true;
  getOrderDetailedStatement(tgtOrdNo.value);
}

// API 호출 준비
const fetchBuilder = useHconFetchBuilder();
// 주문 거래명세서 정보 매핑대상 준비
const ordDsmInfo = ref<DetailedStatementDto>();
const gdsList = ref<ReceiptGoodsDto[]>();
// 주문 거래명세서 정보 조회
const getOrderDetailedStatement = async (ordNo: string) => {
  const ordDsmFetcher =
    fetchBuilder.get<AjaxResult<DetailedStatementDto>>(`/api/v1/mypage/order/detail/${ordNo}/detailed-statement`)
    .progressMessage("잠시만 기다려주세요...")
    .build()
    .execute()
    .then((result) => {
      if(result.resultCode != '200') {
        console.error(result.resultMessage);
      } else {
        // ref 형식 변수에 값 즉시 세팅
        ordDsmInfo.value = result.data;
        gdsList.value = result.data.itemList;
      }        
  });
}

// 취소상품 포함여부
const hasCanceledItem = computed(() => {
  if(!gdsList.value || gdsList.value.length === 0) return false;
  return gdsList.value?.some(item => item.ordGdsInpaCnt > 0);
}); 

// 화면 출력용 합계 계산 로직
const totalAmount = computed(() => { // 거래요약정보 및 품목상세정보 하단의 합계금액 데이터 
  return displayGoodsList.value?.reduce<{summaryNrmlPrc:number, summaryDcAmt:number, summaryAmt:number, 
                                         displayNrmlPrc:number, displayDcAmt:number, displayAmt:number}>((total, item) => {
    total.displayNrmlPrc += Number(item.displayQty) * Number(item.displayNrmlPrc);
    total.displayDcAmt += Number(item.displayQty) * Number(item.displayDcAmt);
    total.displayAmt += Number(item.displayAmt);
    total.summaryNrmlPrc += !showCancelItem.value? Number(item.ordGdsQty) * Number(item.nrmlSellPrc) : Number(item.displayQty) * Number(item.displayNrmlPrc);
    total.summaryDcAmt += !showCancelItem.value? Number(item.ordGdsQty) * Number(item.dcAmt) : Number(item.displayQty) * Number(item.displayDcAmt);
    total.summaryAmt += !showCancelItem.value? Number(item.ordGdsQty) * Number(item.realSellPrc) : Number(item.displayAmt);
    return total;
  }, {summaryNrmlPrc:0, summaryDcAmt:0, summaryAmt:0, displayNrmlPrc:0, displayDcAmt:0, displayAmt:0});
}); 
const displayGoodsList = computed(() => { // 실제 표기할 상품목록
  return gdsList.value?.flatMap(item => {
    // 1. 체크박스 해제 시, 부분취소 건수 빼기 계산
    if(!showCancelItem.value) {
      const remainQty = item.ordGdsQty - item.ordGdsInpaCnt;
      if(remainQty <= 0) {
        return []; // 해당 상품이 모두 취소되었으면 row 없애기
      }
      return [{
        ...item, 
        displayQty: remainQty,
        displayAmt: remainQty * item.realSellPrc,
        displayNrmlPrc: item.nrmlSellPrc,
        displayDcAmt: item.dcAmt,
        isCancelRow: false
      }];
    } 

    // 2. 체크박스 세팅 시, 원거래내역 건수 그대로 출력 + 부분취소 건수 row 추가하기
    const rows = [];
    rows.push({
      ...item,
      displayQty: item.ordGdsQty,
      displayAmt: item.ordGdsQty * item.realSellPrc,
      displayNrmlPrc: item.nrmlSellPrc,
      displayDcAmt: item.dcAmt,
      isCancelRow: false
    });
    if(item.ordGdsInpaCnt > 0) {
      rows.push({
        ...item,
        displayQty: item.ordGdsInpaCnt,
        displayAmt: -item.realSellPrc * item.ordGdsInpaCnt,
        displayNrmlPrc: -item.nrmlSellPrc,
        displayDcAmt: -item.dcAmt,
        isCancelRow: true
      });
    }
    return rows;
  })
});




defineExpose({ handleOpen, handleClose });

</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/order-hcon.scss" as *;
@use "@/assets/scss/pc/mypage-hcon.scss" as *;

@media print {
  .invoice-box {
    width: 50% !important;

    .box-title {
      width: 24px !important;
    }

    .invoice-table {
      width: 100% !important;
    }
  }
}

</style>